import { render, staticRenderFns } from "./configureMealPlanForm.vue?vue&type=template&id=6035bfc9&"
import script from "./configureMealPlanForm.vue?vue&type=script&lang=js&"
export * from "./configureMealPlanForm.vue?vue&type=script&lang=js&"
import style0 from "./configureMealPlanForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports